module.exports = __webpack_public_path__ + "static/media/4.628a46b2.jpg";